import {
    useRef,
    useState
} from 'react';

import {SimpleGrid} from '@mantine/core';

import {useRatePlans} from '../hooks/useRatePlans.ts';
import {useRatePlansSelection} from '../hooks/useRatePlansSelection.ts';
import {useTableColumns} from '../hooks/useTableColumns.tsx';
import {FormDrawer} from '../drawers/FormDrawer.tsx';
import {update} from '../services/RatePlansService.ts';

import {
    MantineDataTable,
    TableSearchForm,
    DataTableTokenPagination,
} from '@flexinet/ui-components';
import {RatePlan} from '../types';
import {useQueryClient} from '@tanstack/react-query';

export const RecordsTable = () => {
    const {selectedRecords, setSelectedRecords} = useRatePlansSelection();
    const [drawerOpened, setDrawerOpened] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<RatePlan | null>(null);
    const queryClient = useQueryClient();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useRatePlans();

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const handleRecordClick = (record: RatePlan) => {
        setSelectedRecord(record);
        setDrawerOpened(true);
    };

    const handleDrawerSubmit = async (values: RatePlan) => {
        if (selectedRecord?.id) {
            const {createdByUsername: _createdByUsername, createdBy: _createdBy, created: _created, updated: _updated, ...rest} = values;
            await update(selectedRecord.id, rest as RatePlan);
            queryClient.invalidateQueries({queryKey: ['rate-plans']});
        }
    };

    const {columns} = useTableColumns({onRecordClick: handleRecordClick});

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword}/>

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination loadedCount={totalCount} nextToken={nextToken}
                                      handleLoadMore={fetchRecords}/>

            {drawerOpened && selectedRecord && (
                <FormDrawer
                    record={selectedRecord}
                    handleSubmit={handleDrawerSubmit}
                    opened={drawerOpened}
                    onClose={() => {
                        setDrawerOpened(false);
                        setSelectedRecord(null);
                    }}
                />
            )}
        </SimpleGrid>
    );
};
